import { render, staticRenderFns } from "./GlossaryTrigger.vue?vue&type=template&id=17d331c4&"
import script from "./GlossaryTrigger.vue?vue&type=script&lang=js&"
export * from "./GlossaryTrigger.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryTrigger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports